import { getTheme, ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';

const theme: ITheme = getTheme();
const { palette } = theme;

export const viewStyles = mergeStyleSets({
    container: {
        position: 'relative',
        height: 'calc(100vh - 30px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    containerWithoutHeader: {
        position: 'relative',
        height: 'calc(100vh - 75px)',
    },
    subItemContainer: {
        position: 'relative',
        // height: 'calc(100vh - 30px)',
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 10,
    },
    twoSearchBarLines: {
        gridTemplateRows: 'max-content max-content 1fr',
    },
    embedded: {
        height: 'calc(100vh - 75px)',
    },
    icons: {
        display: 'grid',
        gridTemplateRows: '1fr max-content',
    },
    save: {
        marginLeft: -1,
        backgroundColor: palette.blue,
        borderRadius: 2,
        color: palette.white,
        padding: 2,
    },
    saving: {
        color: palette.blue,
        animation: 'rotation 2s infinite linear',
    },
    saved: {
        color: palette.green,
    },
    error: {
        color: palette.white,
        backgroundColor: palette.red,
        borderRadius: 2,
        padding: '3px 2px 2px 3px',
    },

    noData: {
        marginTop: 20,
        textAlign: 'center',
    },
    listContainer: {
        overflow: 'hidden',
    },
    listContainerScroll: {
        overflow: 'scroll',
    },
    list: {
        paddingLeft: 0,
    },
});
